import { Box } from '@mui/material'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function InvestmentValue({ report }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: true,
        position: 'bottom',
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
          title: () => null,
        },
      },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          color: 'white',

          callback: function (e) {
            // console.log(moment(data.labels[e]).format('MMM'))
            return moment(data.labels[e]).format('MMM')
          },
        },
      },
      y: {
        stacked: false,
        ticks: { color: 'white' },
        grid: {
          display: true,
          color: 'gray',
        },
      },
    },
  }
  const color = [
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
  ]
  const [data, setRevData] = useState({
    labels: ['2022', '2023', '2024', '2025'],
    datasets: [
      {
        label: '',
        data: [1, 2, 2.5, 6],
        backgroundColor: ['#60829b'],
        borderColor: ['#60829b'],
        barThickness: 10,
      },
    ],
  })
  useEffect(() => {
    setRevData({
      labels: report?.labels,
      datasets: [
        {
          // LAP-733 (GE022)
          label: t('investments.portfolio.invValue.activePortfolio'),
          data: report?.portfolio,
          backgroundColor: ['#60829b'],
          borderColor: ['#60829b'],
          barThickness: 10,
        },
        {
          // LAP-733 (GE022)
          label: t('investments.portfolio.invValue.profitability'),
          data: report?.profitability,
          backgroundColor: ['#95bee5'],
          borderColor: ['#95bee5'],
          barThickness: 10,
        },
      ],
    })
  }, [report, t, i18n.language]) // LAP-733 (GE022) — re-render chart on language switch
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.portfolio.invValue.title')}</Box>
          <Box ml={'auto'}>{report?.total} €</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.portfolio.invValue.yearlyChange')}</Box>
          <Box sx={{ marginLeft: 'auto', color: report?.change > 0 ? 'green' : 'red' }}>
            {report?.change > 0 ? '+' : '-'}
            {report?.change}%
          </Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'}>
        {report?.labels.length > 0 ? (
          <Line data={data} options={optionsbar} />
        ) : (
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'100%'}>
            {/* LAP-733 (GE022) */}
            <Box>{t('investments.portfolio.noInvestmentsYet')}</Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}
